import { render } from "./PostsHomePage.vue?vue&type=template&id=18fe0adf"
import script from "./PostsHomePage.vue?vue&type=script&lang=js"
export * from "./PostsHomePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__